"use client"
import ReactDOM from "react-dom";
import SuccessGif from "../assets/successful.gif";

const IsolatedStatusModal = ({
    buttonText,
  isOpen = false,
  onClose,
  type = "success",
  title = type === "success" ? "Success!" : "Error!",
  message = type === "success"
    ? "Your action was completed successfully."
    : "There was an error processing your request.",
}) => {
  if (!isOpen) return null;

  const colors = {
    success: {
      border: "#FFC857",
      buttonBg: "#FFC857",
      buttonText: "#02111B",
    },
    error: {
      border: "#FFC857",
      buttonBg: "#BB0A21",
      buttonText: "white",
    },
  };

  const modalContent = (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          position: "relative",
          width: "100%",
          maxWidth: "400px",
          backgroundColor: "#02111B",
          border: `1px solid ${colors[type].border}`,

          borderRadius: "8px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
          padding: "24px",
          outline: "none",
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "12px",
            right: "16px",
            color: "white",
            cursor: "pointer",
            background: "none",
            border: "none",
            padding: "0",
            fontSize: "24px",
          }}
        >
          ✕
        </button>

        <div style={{ textAlign: "center" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "16px",
            }}
          >
            {type === "success" ? (
              <img
                src={SuccessGif}
                alt="Success"
                style={{ width: "150px", height: "150px", borderRadius: "50%" }}
              />
            ) : (
              <div
                style={{
                 
                  
                    //  border: `1px solid ${colors[type].border}`,
                  width: "80px",
                  height: "80px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
              </div>
            )}
          </div>

          <h3
            style={{
              color: "white",
              fontSize: "1.5rem",
              fontWeight: "bold",
              marginBottom: "8px",
              fontFamily: "sans-serif",
            }}
          >
            {title}
          </h3>

          <p
            style={{
              color: "white",
              marginBottom: "16px",
              fontFamily: "sans-serif",
            }}
          >
            {message}
          </p>

          <button
            onClick={onClose}
            style={{
              backgroundColor: colors[type].buttonBg,
              color: colors[type].buttonText,
              padding: "8px 24px",
              borderRadius: "4px",
              border: "none",
              fontWeight: "700",
              marginTop: "16px",
              cursor: "pointer",
              fontSize: "16px",
              fontFamily: "sans-serif",
            }}
          >
           {buttonText}
          </button>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default IsolatedStatusModal;
